import { createFileRoute } from "@tanstack/react-router";
import { AiStudioSettings } from "@/components/AiStudio";

export const Route = createFileRoute("/_authenticated/ai-studio/settings/")({
  component: AiStudioSettings,
  staticData: { page: "university" },
});
